import FormattedMessage from 'I18n/components/FormattedMessage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const RemovedFromPortalUserTooltip = ({
  children
}) => /*#__PURE__*/_jsx(UITooltip, {
  placement: "top",
  title: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "routing-ui.routingRules.users.removedFromPortal"
  }),
  children: children
});
RemovedFromPortalUserTooltip.displayName = 'RemovedFromPortalUserTooltip';
export default RemovedFromPortalUserTooltip;